import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const InboundTagStyled = styled.div`
  display: inline-block;
  text-align: center;
  color: ${colors.neutral[900]};
  width: 7.2rem;
  padding: 0.1rem 0;
  border-radius: 4px;
  background-color: ${colors.green[300]};
  font-size: 1.2rem;
  line-height: 1.8rem;
  font-weight: 400;
`;
